import sourceUrl, { newSourceUrl } from "../../../../api/Source.api";
const token = localStorage.getItem('token');
const isLoggedIn = localStorage.getItem('isLoggedIn');


const fetchLanguages = async (setAudioLanguages, setAudioSettingLanguagesLoading) => {
  setAudioSettingLanguagesLoading(true)
    try {
      // const response = await fetch(`${}/audio/language`, {
      const response = await fetch(`${newSourceUrl}/v1/settings/audio/languages?page=1&page_size=10&order=language%20ASC`, {
        method: 'GET',
        credentials: "include",
        headers: {
          ...(isLoggedIn ? { Authorization: `Bearer ${token}` } : {}),
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      const data = await response.json();
      //  console.log('Fetched Language:', data?.data); // Log the response for debugging
      setAudioLanguages(data?.data?.languages); // Assuming the response has a languages array
    } catch (error) {
      console.error('Error fetching languages:', error);
    }
    setAudioSettingLanguagesLoading(false)
  };

  const fetchVoices = async (setAudioSettingVoices,setAudioVoice, audioVoice, setAudioSettingVoicesLoading, setAudioVoiceTotalPages, currentPageForVoices) => {
    setAudioSettingVoicesLoading(true)
    try {
      const url = currentPageForVoices == 1 ? `${newSourceUrl}/v1/settings/audio/voices` : `${newSourceUrl}/v1/settings/audio/voices?page=${currentPageForVoices}`  
      // const response = await fetch(`${sourceUrl}/audio/list`, {
      const response = await fetch(url, {
        method: 'GET',
        credentials: "include",
        headers: {
          ...(isLoggedIn ? { Authorization: `Bearer ${token}` } : {}),
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      const data = await response.json();
      // console.log('Fetched voices:', Math.ceil((data?.data?.total)/(data?.data?.page_size))); // Log the response for debugging
      setAudioSettingVoices(data?.data?.voices);
      setAudioVoiceTotalPages(Math.ceil((data?.data?.total)/(data?.data?.page_size)))
      if (data.data.voices.length > 0 && !audioVoice) {
        // Set default selected voice if none is selected yet
        setAudioVoice(data.data.voices[0].voice_id);
      }
    } catch (error) {
      console.error('Error fetching voices:', error);
    }
    setAudioSettingVoicesLoading(false)
  };

const AudioSettingsAPI = (setAudioLanguages,setAudioSettingVoices,setAudioVoice, audioVoice, setAudioSettingVoicesLoading,setAudioSettingLanguagesLoading , setTotalPages, currentPageForVoices ) =>{
  fetchLanguages(setAudioLanguages, setAudioSettingLanguagesLoading);
  fetchVoices(setAudioSettingVoices,setAudioVoice, audioVoice, setAudioSettingVoicesLoading, setTotalPages, currentPageForVoices);
}

export {AudioSettingsAPI, fetchVoices, fetchLanguages}